import { Stack, styled } from '@mui/material';

export const DropDownStyled = styled(Stack)(({ theme }) => ({
  padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
  gap: theme.spacing(2),
  borderRadius: theme.spacing(6),
  border: `1px solid ${theme.palette.text.fourth}`,
  cursor: 'pointer',
  position: 'relative',
}));

export const DropdownContainer = styled(Stack)(({ theme }) => ({
  position: 'absolute',
  top: '100%',
  left: 0,
  right: 0,
  marginTop: theme.spacing(1),
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.text.fourth}`,
  borderRadius: theme.spacing(3),
  padding: theme.spacing(1),
  zIndex: 1,
}));

export const DropdownOption = styled('div')(({ theme }) => ({
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));
